import { useEffect } from 'react';
import { useFetchCssVars } from 'ContentData/queries/GlobalStylesQuery';
import { useLoadGlobalStylesCssVars } from '../../../hooks/useLoadGlobalStyles';
import { removeAllGlobalStyles } from '../utils/globalStyles';
export const StylesLoader = () => {
  const {
    data
  } = useFetchCssVars({}, {
    bufferTheme: true,
    fetchPolicy: 'cache-and-network'
  });
  useLoadGlobalStylesCssVars(data);
  useEffect(() => {
    return () => {
      removeAllGlobalStyles();
    };
  }, []);
  return null;
};